import { UserProDataSetProperty } from "./user-pro-data-set-property";

export class UserProDataSet {
    id: number = 0;
    userId: number = 0;
    proType: string = '';
    properties: UserProDataSetProperty[] = [];

    static mapProperties(item: any): UserProDataSet {
        return {
            id: item.id,
            userId: item.user,
            proType: item.pro_type,
            properties: item.properties.map(prop => UserProDataSetProperty.mapProperties(prop))
        }

    }
}
